export const UPDATE_FILES_FILTER = "UPDATE_FILES_FILTER"
export const RESET_FILES_FILTER = "RESET_FILES_FILTER"
export const UPDATE_ALL_FILES_FILTER = "UPDATE_ALL_FILES_FILTER"
